import { Stack, Typography } from "@mui/material";

export const AccessDenied = () => {
  return (
    <Stack
      sx={{ width: "100vw", height: "100vh" }}
      alignItems={"center"}
      justifyContent={"center"}
    >
      <Typography sx={{ fontSize: "20px" }}>
        Bạn không có quyền truy cập tính năng này !
      </Typography>
    </Stack>
  );
};
